// "Reset to Best Defaults" (UI polish, 22 Oct 2026): one action, same wording on every scanner settings area,
// that puts back the recommended opportunity-finding configuration. It is distinct from a plain "Reset"
// (which only discards unsaved edits). Where the page has a Save button the defaults are loaded into the
// form and nothing is saved until Save; where a filter is applied instantly, `confirm` asks first.
import React from "react";
import { RotateCcw } from "lucide-react";

export const RESET_DEFAULTS_LABEL = "Reset to Best Defaults";

export default function ResetDefaultsButton({ onReset, confirm = null, disabled = false, testId = "reset-best-defaults", className = "", title }) {
  const click = () => {
    if (confirm && !window.confirm(confirm)) return;
    onReset();
  };
  return (
    <button type="button" onClick={click} disabled={disabled} data-testid={testId}
      title={title || "Restore the recommended settings for finding opportunities"}
      className={`h-8 px-3 rounded-sm border border-[var(--term-border-strong)] text-xs inline-flex items-center gap-1.5 text-[var(--term-secondary)] hover:text-[var(--term-primary)] hover:bg-[var(--term-hover)] disabled:opacity-40 ${className}`}>
      <RotateCcw className="h-3.5 w-3.5" />{RESET_DEFAULTS_LABEL}
    </button>
  );
}
